/* FlyHugz price localizer v6 — rewrites hard-coded USD price text into the shopper's market
   currency. Display-only; no-op in USD sessions.
   Design notes (hard-won):
   - Tier "paid" counts come from the page's own advertised USD ratios (captured into data-fh-usd
     BEFORE any conversion) — select-count heuristics break across page families.
   - Tier selects / gift tiles may reference another product's variants: fall back to a sibling
     tier's unit and to F = pageUnit/usd1 (the EXACT market factor incl. price adjustments;
     Shopify.currency.rate is plain FX and understates).
   - Leftover $ texts live in class-less nodes (mobile selects, section-subs): a TreeWalker text
     pass converts every visible "$X" using F (or rate when F unknown).
   - Loop-proofing (CAD formats as "CA$"): never match "$" preceded by a letter; cache each node's
     last output; skip self-localizing scopes (.fhbm*). */
(function () {
  try {
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!cur || cur === 'USD') return;
    var fmt = function (n) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); }
      catch (e) { return cur + ' ' + (Math.round(n * 100) / 100).toFixed(2); }
    };
    var USD_RE = /\$\s?(\d+(?:,\d{3})*(?:\.\d{1,2})?)/;
    var usdNum = function (t) { var m = String(t || '').match(USD_RE); return m ? parseFloat(m[1].replace(/,/g, '')) : null; };
    var rate = parseFloat((Shopify.currency && Shopify.currency.rate) || '0');
    var F = null;   // exact market factor, set once the bogo product .js resolves
    var pm = null;  // variant id -> market price

    /* capture the page's original USD numbers before anything converts them */
    function captureOriginals() {
      document.querySelectorAll('.bogo-opt').forEach(function (opt) {
        if (!opt.dataset.fhUsd) { var v = usdNum((opt.querySelector('.bogo-price-new') || {}).textContent); if (v) opt.dataset.fhUsd = String(v); }
        if (!opt.dataset.fhUsdEa) { var e = usdNum((opt.querySelector('.bogo-unit') || {}).textContent); if (e) opt.dataset.fhUsdEa = String(e); }
        opt.querySelectorAll('.gp-tile .gp-value s').forEach(function (s) {
          if (!s.dataset.fhUsd) { var g = usdNum(s.textContent); if (g) s.dataset.fhUsd = String(g); }
        });
      });
    }
    captureOriginals();

    function precisePass() {
      if (!pm) return;
      captureOriginals();
      var opts = document.querySelectorAll('.bogo-opt');
      if (!opts.length) return;
      var usd1 = null;
      opts.forEach(function (o) { var v = parseFloat(o.dataset.fhUsd); if (v && (usd1 === null || v < usd1)) usd1 = v; });
      var pageUnit = null;
      opts.forEach(function (opt) {
        if (pageUnit) return;
        var sels = opt.querySelectorAll('.bogo-colors select');
        if (!sels.length) return;
        var o0 = sels[0].options[sels[0].selectedIndex];
        var u = o0 && pm[o0.dataset.variantId];
        if (u) pageUnit = u;
      });
      if (pageUnit && usd1) F = pageUnit / usd1;
      opts.forEach(function (opt) {
        try {
          var sels = opt.querySelectorAll('.bogo-colors select');
          if (!sels.length) return;
          var o0 = sels[0].options[sels[0].selectedIndex];
          var unit = (o0 && pm[o0.dataset.variantId]) || pageUnit;
          if (!unit) return;
          var usdN = parseFloat(opt.dataset.fhUsd);
          var paid = (usdN && usd1) ? Math.max(1, Math.round(usdN / usd1)) : Math.max(1, Math.round(sels.length / 2));
          var now = unit * paid, was = now * 2;
          var set = function (el, txt) { if (el && el.textContent !== txt) { el.textContent = txt; var tn = el.firstChild; if (tn && tn.nodeType === 3) tn.__fhOut = tn.nodeValue; } };
          set(opt.querySelector('.bogo-price-new'), fmt(now));
          set(opt.querySelector('.bogo-price-old'), fmt(was));
          var elU = opt.querySelector('.bogo-unit');
          var usdEa = parseFloat(opt.dataset.fhUsdEa);
          if (elU && usdEa && F) set(elU, 'Just ' + fmt(usdEa * F) + ' ea.');
          var elS = opt.querySelector('.bogo-savings');
          if (elS && /(^|[^A-Za-z])\$\d/.test(elS.textContent)) { elS.textContent = 'Save ' + fmt(was - now); var sn = elS.firstChild; if (sn && sn.nodeType === 3) sn.__fhOut = sn.nodeValue; }
          opt.querySelectorAll('.gp-tile').forEach(function (t) {
            var s = t.querySelector('.gp-value s'); if (!s) return;
            var c = t.querySelector('.gp-color');
            var gv = (c && pm[c.dataset.variantId]) || (parseFloat(s.dataset.fhUsd) && F ? parseFloat(s.dataset.fhUsd) * F : null);
            if (gv) set(s, fmt(gv));
          });
        } catch (e) {}
      });
    }

    if (document.querySelector('.bogo-opt')) {
      fetch(location.pathname.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (pj) {
          pm = {}; (pj.variants || []).forEach(function (v) { pm[v.id] = v.price / 100; });
          precisePass(); textPass();
          setTimeout(function(){ precisePass(); textPass(); }, 1200);
          setTimeout(function(){ precisePass(); textPass(); }, 3000);
        }).catch(function () {});
    }

    /* page-wide $-text conversion: every visible text node (incl. select options, class-less
       paragraphs, mockup sections). Uses F when known (exact), else Shopify's plain rate. */
    var RE = /(^|[^A-Za-z$])\$(\d+(?:,\d{3})*(?:\.\d{1,2})?)/g;
    function textPass() {
      var factor = F || (rate > 0 && Math.abs(rate - 1) > 1e-9 ? rate : null);
      if (!factor) return;
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = w.nextNode())) {
        try {
          var t = node.nodeValue;
          if (!t || t.indexOf('$') === -1) continue;
          if (node.__fhOut === t) continue;
          var p = node.parentElement;
          if (!p) continue;
          var tag = p.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
          if (p.closest && p.closest('[class*="fhbm"],#fhCartDrawer,[class*="klaviyo"],[class*="kl-private"],[id*="klaviyo"]')) continue; /* self-localizing + never touch Klaviyo popup DOM (React throws on external mutations -> leaked scroll lock) */
          RE.lastIndex = 0;
          if (!RE.test(t)) continue;
          RE.lastIndex = 0;
          var out = t.replace(RE, function (_, pre, n) { return pre + fmt(parseFloat(n.replace(/,/g, '')) * factor); });
          node.nodeValue = out;
          node.__fhOut = out;
        } catch (e) {}
      }
    }
    textPass();

    var deb;
    new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var m=ms[i],v=null;var te=m.target&&(m.target.nodeType===3?m.target.parentElement:m.target);if(te&&te.closest&&te.closest('[class*="klaviyo"],[class*="kl-private"],[id*="klaviyo"]'))continue;if(m.type==='characterData')v=m.target.nodeValue;else if(m.type==='childList'&&m.addedNodes.length===1&&m.addedNodes[0].nodeType===3&&m.removedNodes.length<=1)v=m.addedNodes[0].nodeValue;if(v===null||!/^[\d:.,\s]*$/.test(v)){clearTimeout(deb);deb=setTimeout(function(){precisePass();textPass();},250);return;}}}).observe(document.body, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();
